export default __webpack_public_path__ + "static/media/GA_ReSynth-4.48496097.wav";